import { combineReducers } from 'redux'
import app_token from './app_token'
import fuelTracker from './fuelTracker'

const RiskPlanningApp = combineReducers({
  app_token: app_token,
  fuelTracker: fuelTracker,
})

export default RiskPlanningApp



// WEBPACK FOOTER //
// ./src/reducers/index.js